import { Component, OnInit } from '@angular/core';
import { Student } from '../student-list/student';
import { OrgService } from '../_services/org.service';
import { StudentService } from '../_services/student.service';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
	constructor(private orgService: OrgService, public StudentService: StudentService) {}

	ngOnInit(): void {
		this.orgService.init();
	}
	init(student: Student) {}
}
